import { Box, Popover, Portal, Text, VStack } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FilterButton,
  FilterButtonAction,
  FilterButtonActiveOptions,
  FilterButtonLabel,
  FilterButtonMenu,
  FilterButtonMenuHeader,
  FilterMenuItem,
} from '@/components/filters/filter-button';

interface MentionTypeFilterProps {
  value: string;
  onChange: (type: string) => void;
  initialValue?: string;
}

const mentionTypeOptions = [
  { value: 'story', translationKey: 'filters.mentionType.story' },
  { value: 'post', translationKey: 'filters.mentionType.post' },
  { value: 'reel_caption', translationKey: 'filters.mentionType.reel' },
] as const;

export const MentionTypeFilter: React.FC<MentionTypeFilterProps> = ({
  value,
  onChange,
  initialValue = '',
}) => {
  const { t } = useTranslation();
  const [tempType, setTempType] = useState<string>(initialValue);

  useEffect(() => {
    setTempType(value);
  }, [value]);

  const handleApply = () => {
    onChange(tempType);
  };

  const handleClear = () => {
    setTempType('');
    onChange('');
  };

  const handleTypeSelect = (type: string) => {
    setTempType(type);
  };

  const isFilterActive = !!value;
  const selectedOption = mentionTypeOptions.find((option) => option.value === value);

  return (
    <FilterButton isFilterActive={isFilterActive} onClearFilter={handleClear}>
      <FilterButtonAction>
        <FilterButtonLabel>{t('filters.mentionType.label')}</FilterButtonLabel>
        {isFilterActive && (
          <FilterButtonActiveOptions>
            {selectedOption ? t(selectedOption.translationKey) : t('filters.mentionType.allTypes')}
          </FilterButtonActiveOptions>
        )}
      </FilterButtonAction>
      <Portal>
        <Popover.Positioner>
          <FilterButtonMenu onApply={handleApply} maxWidth="200px">
            <FilterButtonMenuHeader
              title={t('filters.mentionType.label')}
              onClearAll={handleClear}
            />
            <Box p={3}>
              <VStack gap={0.5} align="stretch">
                {mentionTypeOptions.map((option) => (
                  <FilterMenuItem
                    key={option.value}
                    onClick={() => handleTypeSelect(option.value)}
                    isSelected={tempType === option.value}
                  >
                    <Text fontSize="sm">{t(option.translationKey)}</Text>
                  </FilterMenuItem>
                ))}
              </VStack>
            </Box>
          </FilterButtonMenu>
        </Popover.Positioner>
      </Portal>
    </FilterButton>
  );
};
